import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { formatPostcode } from '../../../utils/utils';
import BillingAddressDialog from './BillingAddressDialog';
import SectionHead from '../../common/SectionHead';

const triple = 3;
const styles = theme => ({
  container: {
    width: '100%',
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing.unit * triple,
    marginLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
  },

  item: {
    display: 'flex',
    alignItems: 'center',
  },

  flex: {
    flex: 1,
  },

  button: {
    color: '#FFFFFF',
    backgroundColor: '#1A65FF',
    borderRadius: '2px',
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },

  caption: {
    marginTop: '10px',
    fontSize: '13px',
    color: '#71737B',
  }
});

class BillingPanel extends React.Component {
  componentWillMount() {
    let { routerInfo } = this.props;
    if (routerInfo && routerInfo.state && typeof routerInfo.state.initValue === 'object') {
      let initValue = routerInfo.state.initValue;
      for (let p in initValue) {
        if (this.state.hasOwnProperty(p)) {
          this.setState({ [p]: initValue[p] })
        }
      }
    }
  }

  state = {
    showBillingAddressDialog: false,
  }

  toggleBillingAddressDialog = () => {
    this.setState({ showBillingAddressDialog: !this.state.showBillingAddressDialog });
  }

  renderBillingAddress = () => {
    const { classes, paymentInfo } = this.props;
    let info;
    if (paymentInfo) {
      info = (
        <div className={classes.row}>
          <div className={classes.flex}>
            <Typography variant="subheading">
              {`${paymentInfo.bill_company ? paymentInfo.bill_company + ' ' : ''}${paymentInfo.bill_name}`}
            </Typography>

            {(paymentInfo.bill_post_code || paymentInfo.bill_address) && (<Typography className={classes.caption}>{`${paymentInfo.bill_post_code ? formatPostcode(paymentInfo.bill_post_code) : ''}${paymentInfo.bill_address}`}</Typography>)}
          </div>
          <Button
            color="primary"
            className={classNames(classes.item, classes.button)}
            onClick={this.toggleBillingAddressDialog}>
            編集
          </Button>
        </div>
      );
    } else {
      info = (
        <div className={classes.row}>
          <div className={classes.flex}>
            <Typography variant="subheading">
              請求先情報が設定されていません。
            </Typography>
          </div>

          <Button
            color="primary"
            variant="raised"
            className={classNames(classes.item, classes.button)}
            onClick={this.toggleBillingAddressDialog}>
            設定する
          </Button>
        </div>
      )
    }

    return (
      <div>
        <SectionHead title="請求先情報" />
        {info}
      </div>
    );
  }

  renderBillingAddressDialog = () => {
    const {
      paymentInfo,
      updatePaymentInfo,
      postPaymentInfo,
      isSaving,
      error } = this.props;

    return (
      <BillingAddressDialog
        isOpen={this.state.showBillingAddressDialog}
        toggleDialog={this.toggleBillingAddressDialog}
        paymentInfo={paymentInfo}
        updatePaymentInfo={paymentInfo ? updatePaymentInfo : postPaymentInfo}
        isSaving={isSaving}
        error={error}
      />
    )
  }

  render() {
    const { classes } = this.props;

    let billingAddressDialog;
    if (this.state.showBillingAddressDialog) { billingAddressDialog = this.renderBillingAddressDialog(); }

    return (
      <div className={classes.container}>
        {this.renderBillingAddress()}
        {billingAddressDialog}
      </div>
    );
  }
}

BillingPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  paymentInfo: PropTypes.object,
  updatePaymentInfo: PropTypes.func.isRequired,
  postPaymentInfo: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  routerInfo: PropTypes.object,
};

BillingPanel.defaultProps = {
  paymentInfo: null,
  isSaving: false,
  error: {},
};

export default withStyles(styles)(BillingPanel);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Billing/BillingPanel.jsx